const MapZoom = {
    WORLD: 1,
    CONTINENT: 5,
    CITY: 10,
    STREETS: 15,
    BUILDINGS: 20,
};

export default MapZoom;